import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

export const theme = ref<'default' | 'pocket-pills'>('default');
export const enableIntercom = ref(true);
export const enableAveeLogo = ref(true);
export const enableCurvedButton = ref(false);
export const enableSwitchingUser = ref(true);
export const alternativeSuccessURL = ref<Nullable<string>>(null);
export const alternativeFailureURL = ref<Nullable<string>>(null);
export const isInPerson = computed(() => {
    const route = useRoute();

    if (!route?.params.domain) {
        return false;
    }

    return (route?.params.domain as string).endsWith('avee-willowbrook');
});
